import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { MedicationsFormValues } from "./interface";

const MEDICATION_ADHERENCE_LABELS: Record<string, string> = {
  NOT_PRESCRIBED: "Not prescribed",
  REGULARLY_MISSES_DOSES: "Regularly misses doses",
  FREQUENT_CHALLENGING_BEHAVIOR: "Frequent challenging behavior around medication",
  OCCASIONALLY_MISSES_DOSE: "Occasionally misses a dose",
  ON_SCHEDULE_WITH_SUPPORT: "On schedule with caregiver support",
  ON_SCHEDULE_100_INDEPENDENT: "On schedule, 100% independent",
};

interface ViewFieldsProps {
  formValues: MedicationsFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Medication Adherence"
        value={MEDICATION_ADHERENCE_LABELS[formValues.medicationAdherence] || formValues.medicationAdherence || "-"}
      />
      <LabeledText
        label="Coordination of Care Notes"
        value={formValues.coordinationOfCareNotes || "-"}
      />
    </Grid>
  );
};

export default ViewFields;
